import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Handshake, CreditCard, ShoppingCart, Gavel, Scale } from 'lucide-react';
const modules = [{
  icon: <BookOpen className="w-6 h-6" data-id="element-106" data-mp="1vx2awcxf9qs5" />,
  title: 'Legislación y Fundamentos Jurídicos',
  desc: 'Toda la normativa, doctrina y criterios legales organizados para encontrar rápidamente el respaldo jurídico que necesitás en cada reclamo.'
}, {
  icon: <Handshake className="w-6 h-6" data-id="element-107" data-mp="1477j89m3dp0b" />,
  title: 'Reclamos Administrativos Profesionales',
  desc: 'Procedimientos, estrategias y herramientas prácticas para gestionar reclamos administrativos con mayor rapidez y seguridad.'
}, {
  icon: <CreditCard className="w-6 h-6" data-id="element-108" data-mp="1i5nr43voxlk1" />,
  title: 'Bancos, Tarjetas y Estafas Digitales',
  desc: 'Material especializado para resolver conflictos financieros, consumos desconocidos, fraudes electrónicos y billeteras virtuales.'
}, {
  icon: <ShoppingCart className="w-6 h-6" data-id="element-109" data-mp="2tjrgewrc2lir" />,
  title: 'Compras Online, Servicios y Seguros',
  desc: 'Todo lo necesario para abordar reclamos por comercio electrónico, productos defectuosos, garantías, telefonía, internet, seguros y servicios públicos.'
}, {
  icon: <Gavel className="w-6 h-6" data-id="element-110" data-mp="3ozivi7p1ibf5" />,
  title: 'Litigación Judicial y Estrategias Procesales',
  desc: 'Estrategias, herramientas y recursos para preparar demandas, organizar expedientes y litigar con mayor respaldo profesional.'
}, {
  icon: <Scale className="w-6 h-6" data-id="element-111" data-mp="3f35z32241jgp" />,
  title: 'Jurisprudencia y Casos Prácticos',
  desc: 'Fallos relevantes, criterios actuales y casos aplicados para fortalecer cada reclamo y tomar decisiones con mayor seguridad jurídica.'
}];
export const Modules = () => {
  return <section className="py-12 bg-legal-800 border-y border-legal-700" data-id="element-112" data-mp="31b99p5rttno0">
      <div className="container mx-auto px-4" data-id="element-113" data-mp="2watzgn2ucwa9">
        <div className="text-center mb-10 max-w-3xl mx-auto" data-id="element-114" data-mp="2waloj0qa411p">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-115" data-mp="2rbqt8zb4kk0p">
            ¿Qué incluye el Tratado?
          </h2>
        </div>

        <div className="max-w-4xl mx-auto space-y-4" data-id="element-116" data-mp="2hqhgqv2m2nfc">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.08
        }} className="group flex gap-5 md:gap-6 bg-legal-900 border border-legal-700 hover:border-gold-500/50 rounded-xl p-6 md:p-7 transition-colors" data-id="element-117" data-mp="2moson09cinux" data-mpi={idx}>
              {/* Number + icon */}
              <div className="shrink-0 flex flex-col items-center" data-id="element-118" data-mp="3jds2cusp8hui">
                <span className="font-serif text-4xl md:text-5xl font-bold text-gold-500/30 leading-none group-hover:text-gold-500/60 transition-colors" data-id="element-119" data-mp="3jcgyyw361c3x">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <span className="mt-3 flex items-center justify-center w-11 h-11 rounded-lg bg-gold-500/10 text-gold-500" data-id="element-120" data-mp="17qepfj85str7">
                  {mod.icon}
                </span>
              </div>

              <div className="border-l border-legal-700 pl-5 md:pl-6" data-id="element-121" data-mp="1hg826nk1fex1">
                <span className="text-xs font-semibold tracking-widest uppercase text-gold-500/80" data-id="element-122" data-mp="1hgzwzw5t98m9">
                  Módulo {idx + 1}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white mt-1 mb-2 leading-snug" data-id="element-123" data-mp="osc87qlus13y">
                  {mod.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-124" data-mp="13mqhv0jj1y5y">{mod.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};